import { TFunction } from "i18next";
import { z } from "zod";

export const documentsUploadSchema = (t: TFunction) => {
  const documentSchema = z.object({
    file: z.instanceof(File).nullable(),
    existing: z.boolean(),
    fileId: z.string().optional(),
    fileName: z.string().optional(),
    expirationDate: z.string().optional(),
  });

  return z.record(documentSchema).superRefine((documents, ctx) => {
    Object.entries(documents).forEach(([docCode, document]) => {
      if (document.expirationDate) {
        // Vérifier que le document a été uploadé si une date de validité est renseignée
        const hasFile = !!document.file || !!document.fileName || !!document.fileId;
        if (!hasFile) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t("folder.documents.error.expirationDateWithoutDocument"),
            path: [docCode, "expirationDate"],
          });
        }

        const expirationDate = new Date(document.expirationDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        expirationDate.setHours(0, 0, 0, 0);

        if (expirationDate < today) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t("folder.documents.error.expirationDateInPast"),
            path: [docCode, "expirationDate"],
          });
        }
      }
    });
  });
};
